import api from './client';

export const fetchPermissions = (roleId) =>
  api.get(`/admin/rbac_roles/${roleId}/role_permissions`);

export const savePermissions = (roleId, changes) =>
  api.put(`/admin/rbac_roles/${roleId}/role_permissions`, { changes });

export const resetRole = (roleId) =>
  api.post(`/admin/rbac_roles/${roleId}/role_permissions/reset`);
